var _style, _path, _path2, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000099;stroke-width:14.2105;stroke-miterlimit:10;}\n\t.st1{fill:#000099;}\n\t.st2{fill:none;stroke:#000099;stroke-width:14;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#000099;stroke-width:12;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#000099;stroke-width:11;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#000099;stroke-width:10;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M167.07,99.99c0,37.05-30.03,67.08-67.06,67.08c-37.05,0-67.08-30.03-67.08-67.08 c0-37.03,30.03-67.07,67.08-67.07C137.05,32.93,167.07,62.96,167.07,99.99z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M121.16,78.73c0,0-5.95-12.68-20.02-12.89c-12.82-0.19-17.87,7.21-17.87,7.21s-7.37,8.9,0.71,17.21 c3.17,3.26,7.4,5.5,16.28,8.12s21.36,7.39,21.12,18.32s-8.41,14.27-8.41,14.27s-13.48,7.91-26.99-1.2 c-3.61-2.43-6.04-6.05-7.35-8.41"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 100,
    y1: 48,
    x2: 100,
    y2: 152
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/price.448dbb919ad3d970ba3714d547bf3a51.svg";
export { ForwardRef as ReactComponent };